import React from 'react';
import { toast } from 'sonner';
import { Check } from 'lucide-react';
import { adminSettleListing } from '../../lib/api';
import { money, LISTING_BADGE_CLS } from './shared';

export default function MarketTab({ listings, onChanged }) {
  const settle = async (l) => {
    try { await adminSettleListing(l.id); toast.success('Settled. Ownership transferred'); onChanged(); }
    catch (err) { toast.error(err?.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-white/10">
      {listings.length === 0 ? <p className="px-6 py-8 text-farmway-cream/50">No listings.</p> : listings.map((l) => (
        <div key={l.id} className="grid grid-cols-2 items-center gap-4 border-t border-white/10 px-6 py-4 first:border-t-0 md:grid-cols-6">
          <div className="col-span-2"><p className="text-sm font-medium text-farmway-cream">{l.projectName}</p><p className="text-xs text-farmway-cream/50">{l.sellerEmail}{l.buyerEmail ? ` → ${l.buyerEmail}` : ''}</p></div>
          <p className="text-sm text-farmway-cream/70">Ask {money(l.askPrice)}</p>
          <p className="text-sm text-farmway-cream/70">{l.acceptedBid ? `Accepted ${money(l.acceptedBid.amount)}` : `Val ${money(l.valuation)}`}</p>
          <span className={`justify-self-start rounded-full px-3 py-1 font-display text-[11px] font-bold uppercase tracking-wider ${LISTING_BADGE_CLS[l.status] || 'bg-white/10 text-farmway-cream/70'}`}>{l.status.replace('_', ' ')}</span>
          <div className="text-right">{l.status === 'pending_settlement' && <button onClick={() => settle(l)} className="inline-flex items-center gap-1 rounded-full bg-farmway-gold px-3 py-1.5 text-[11px] font-bold uppercase text-farmway-green"><Check className="h-3 w-3" />Settle</button>}</div>
        </div>
      ))}
    </div>
  );
}
